<template>
  <div id="list_com" class="relativeItem">
    <img class="imgBlock noevents-img" src="../../assets/flower/bimg01.png" />
    <div class="ctr_con">
      <!-- 搜索 -->
      <div class="search_box relativeItem" v-if="showSearchBox">
        <img
          class="imgBlock noevents-img ssicon absoluteItem"
          src="../../assets/flower/ssicon.png"
        />
        <input
          type="text"
          v-model="keyWord"
          placeholder="输入朱贝号或昵称进行搜索"
        />
        <div class="ss_btn absoluteItem" @click="searchFun">
          <img
            class="imgBlock noevents-img"
            src="../../assets/flower/ssuo.png"
          />
        </div>
      </div>

      <div :class="['tit_top', { matop_zero: !showSearchBox }]">
        <div class="flex-box tit_div">
          <p>排名</p>
          <p>名称&头像</p>
          <p>{{ titText }}阳光值</p>
        </div>
      </div>

      <div>
        <ul class="ul_box" v-if="rankList.length > 0">
          <li v-for="(n, i) in rankList" :key="i">
            <div class="flex-box div_li">
              <div class="flex-box line_con">
                <div class="pai_con" v-if="!ssList">
                  <img
                    v-if="i == 0"
                    class="imgBlock noevents-img"
                    src="../../assets/flower/pai1.png"
                  />
                  <img
                    v-else-if="i == 1"
                    class="imgBlock noevents-img"
                    src="../../assets/flower/pai2.png"
                  />
                  <img
                    v-else-if="i == 2"
                    class="imgBlock noevents-img"
                    src="../../assets/flower/pai3.png"
                  />
                  <p v-else>{{ i + 1 }}</p>
                </div>
                <div class="pai_con" v-if="ssList">-</div>
                <div class="flex-box u_info">
                  <!-- 点击头像的操作 -->
                  <div class="avat_con" @click="goMyFlower(n)">
                    <img
                      class="imgBlock noevents-img"
                      :src="n.avatar"
                      onerror="this.src = 'http://oss.3yakj.com/application_static_data/static_data/publicimg/img.jpg'"
                    />
                  </div>
                  <p class="uname_con apostrophe">{{ n.nickname }}</p>
                </div>
              </div>
              <p class="sun_con" v-if="n.get_sunny_amount">
                {{ n.get_sunny_amount }}
              </p>
              <p class="sun_con" v-if="n.pay_sunny_amount">
                {{ n.pay_sunny_amount }}
              </p>

              <p class="sun_con" v-if="n.sunny_amount">{{ n.sunny_amount }}</p>
            </div>
          </li>
        </ul>

        <div class="kong_box" v-if="showNo">
          <img
            class="imgBlock noevents-img"
            src="../../assets/flower/bei.png"
          />
          <p v-if="showStext">暂无数据，快来上榜吧~</p>
          <p v-else>未搜索到此用户~</p>
        </div>
      </div>
    </div>
    <img class="imgBlock noevents-img" src="../../assets/flower/bimg03.png" />
  </div>
</template>








<script>
export default {
  props: [
    "titText",
    "rankList",
    "showSearchBox",
    "isAnchor",
    "btnIdx",
    "showNo",
    "showStext",
    "meBangUid",
  ],
  data() {
    return {
      keyWord: "", //搜索的字段
      // showEmpty: false,
      ssList: false, // 是否是搜索出来的
    };
  },
  mounted() {},
  methods: {
    //获取榜单信息
    getRankList(ziApi) {
      let _this = this,
        newList = [];
      this.$jsonp(this.$apis(ziApi), {}, (res) => {
        if (res.data.ret == 200) {
          newList = res.data.data.list;
          newList.forEach((ele) => {
            if (ele.sunny_amount * 1 > 999999) {
              ele.sunny_amount = _this.textOverSix(ele.sunny_amount * 1);
            }
          });
          if (newList.length == 0) {
            // _this.showEmpty = true;
            _this.$emit("changeStext");
          }

          _this.$emit("updateList", newList);
        } else {
          _this.$tool.tipImg(res.data.data, "error");
        }
      });
    },

    searchFun() {
      if (this.keyWord.trim() == "") {
        this.ssList = false;
        this.$emit("changeEmptyFalse");
        // this.$tool.tip("请输入要搜索的关键字", "50%");
        if (this.btnIdx == 1) {
          this.getRankList("flower_rankListAor");
        } else {
          this.getRankList("flower_rankListUser");
        }
        return;
      }
      let _this = this,
        newList = [],
        data = {
          words: _this.keyWord,
          type: _this.btnIdx, // 1主播  2用户
        };
      this.$jsonp(this.$apis("flower_search"), data, (res) => {
        if (res.data.ret == 200) {
          newList = res.data.data.list;
          newList.forEach((ele) => {
            if (ele.sunny_amount * 1 > 999999) {
              ele.sunny_amount = _this.textOverSix(ele.sunny_amount * 1);
            }
          });
          if (res.data.data.list.length == 0) {
            // _this.showEmpty = true;
            _this.$emit("changeStext");
          }
          _this.ssList = true;

          _this.$emit("updateList", newList);
        } else {
          _this.$tool.tipImg(res.data.data, "error");
        }
      });
    },

    // 过万的处理
    textOverSix(value) {
      if (value > 999999 && value <= 9999999) {
        value = (value / 10000).toFixed(2) + "w";
      } else if (value > 9999999 && value <= 99999999) {
        value = (value / 10000000).toFixed(2) + "kw";
      } else if (value > 99999999) {
        //过亿的处理
        value = (value / 100000000).toFixed(2) + "e";
      }
      return value;
    },

    // 点击前往花卉页面
    goMyFlower(obj) {
      if (this.btnIdx == 456) {
        return;
      }
      let anchorId = obj.user_id; // 主播榜的id
      //主播用anchorId   用户用bindId   链接添加isme就是我的花卉   没有就是他的花卉
      if (this.btnIdx == 2) {
        //用户榜的点击
        let uFid = 0; // 用户榜的花的id
        if (obj.bind_room_uid) {
          uFid = obj.bind_room_uid;
        }
        // 如果用户的meBangUid和榜单点击的bind_room_uid相等  就是我的花卉   不等就是他的
        if (this.meBangUid == uFid) {
          this.$router.push({
            path: "/myFlower?isme=0&bindid=" + uFid + "&ident=" + this.isAnchor,
          });
        } else {
          // 未绑
          this.$router.push({
            path:
              "/myFlower?bindid=" +
              uFid +
              "&ident=" +
              this.isAnchor +
              "&meBid=" +
              this.meBangUid,
          });
        }
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        if (this.meBangUid == anchorId) {
          //主播榜的点击
          this.$router.push({
            path:
              "/myFlower?isme=0&bindid=" + anchorId + "&ident=" + this.isAnchor,
          });
        } else {
          //主播榜的点击 未绑
          this.$router.push({
            path:
              "/myFlower?bindid=" +
              anchorId +
              "&ident=" +
              this.isAnchor +
              "&meBid=" +
              this.meBangUid,
          });
        }
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    },
  },
};
</script>















<style lang="scss" scoped>
#list_com {
  width: 100%;
}
.rank_main {
  margin-top: -3px;
}
.search_box {
  width: 243px;
  height: 39px;
  margin: 0 auto;
  border-radius: 18px;
  background: -webkit-linear-gradient(top, #b77541, #fff);
  background: linear-gradient(to bottom, #b77541, #fff);
  padding: 1px 0;
  box-sizing: border-box;
}
.search_box input {
  width: 100%;
  height: 37px;
  background-color: #ebc293;
  border-radius: 18px;
  padding-left: 30px;
  color: #ce8443;
  box-sizing: border-box;
}
input::-webkit-input-placeholder {
  font-size: 0.75rem;
  color: #ce8443;
}
input:-moz-placeholder {
  font-size: 0.75rem;
  color: #ce8443;
}
input::-moz-placeholder {
  font-size: 0.75rem;
  color: #ce8443;
}
.ssicon {
  width: 14px;
  height: 14px;
  top: 53%;
  left: 4%;
  transform: translateY(-50%);
}
.ss_btn {
  height: 36px;
  top: 49%;
  right: 1px;
  transform: translateY(-50%);
}
.ss_btn img {
  width: 62px;
  height: 36px;
}
/* 选择的点击动画 */
.anmateClass {
  animation: btnAni 0.2s linear alternate;
}

.ctr_con {
  width: 100%;
  min-height: 500px;
  background: url("../../assets/flower/bimg02.png") left top repeat;
  background-size: 100%, 100%;

  .tit_top {
    width: 72%;
    margin: 16px auto 8px;
    border-radius: 0.5rem;
    background: -webkit-linear-gradient(top, #e8ba87, #fff2dc);
    background: linear-gradient(to bottom, #e8ba87, #fff2dc);
    padding: 1px 0;
    .tit_div {
      background-color: #fad6a4;
      border-radius: 0.5rem;
      font-size: 0.75rem;
      font-weight: bold;
      color: #cf8653;
      justify-content: space-between;
      padding: 0.375rem 0.75rem;
    }
  }
  .matop_zero {
    margin-top: 0;
  }
  .ul_box {
    width: 72%;
    margin: 0 auto;
    min-height: 400px;
    max-height: 586px;
    overflow-y: scroll;
    li:nth-child(1) {
      margin-top: 0;
    }
    li {
      width: 100%;
      height: 70px;
      border-radius: 8px;
      margin: 8px 0 0;
      background: -webkit-linear-gradient(top, #e8ba87, #fff2dc);
      background: linear-gradient(to bottom, #e8ba87, #fff2dc);
      padding: 1px 0;
      .div_li {
        background-color: #fad6a4;
        align-items: center;
        border-radius: 8px;
        height: 68px;
        .line_con {
          width: 68%;
          justify-content: space-around;
          align-items: center;
          .pai_con {
            width: 30px;
            margin-left: 16px;
            text-align: center;
            p {
              width: 26px;
              text-align: center;
              font-size: 0.9375rem;
              color: #af541f;
              font-weight: bold;
            }
            img {
              width: 26px;
              height: 18px;
            }
          }
          .u_info {
            margin-left: 16px;
            align-items: center;
          }
          .avat_con {
            width: 3.125rem;
            height: 3.125rem;
            border-radius: 50%;
            overflow: hidden;
            img {
              width: 3.125rem;
              height: 3.125rem;
            }
          }
          .uname_con {
            width: 80px;
            font-size: 0.9375rem;
            color: #af541f;
            margin-left: 10px;
          }
        }
        .sun_con {
          width: 28%;
          font-size: 14px;
          font-weight: bold;
          color: #cf8653;
          margin-left: 8%;
        }
      }
    }
  }
}
.kong_box img {
  width: 32%;
  margin: 128px auto 0;
}
.kong_box p {
  width: 100%;
  text-align: center;
  font-size: 13px;
  font-weight: bold;
  color: #cf8653;
}
</style>